// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module_container_bpqQz","wrapper":"index-module_wrapper_CzV3j","tip-text":"index-module_tip-text_3Vf0g"};